import moment from "moment";

const HelperService = {
  dateFormatter(dateString: string) {
    return moment(dateString).format("DD/MM/YYYY");
  },

  dataFormatterYYYYMMDD(data: any) {
    return moment(data).format("YYYY-MM-DD");
  },

  formatDateDDMMMYYYYShort(date: string) {
    if (!date) return "";
    return moment(date).format("DD MMM YYYY");
  },

  allowOnlyNumericValue(e: any, maxlength?: any) {
    var numbers = /^[0-9]$/;
    if (!e.key.match(numbers) && e.keyCode != 8) {
      e.preventDefault();
      return false;
    }

    if (maxlength > 0) {
      if (e.key != "Backspace" && e.target.value.length >= maxlength) {
        e.preventDefault();
        return false;
      }
    }
  },
  getFormatedDate(d: any) {
    return d ? moment.utc(d).format("DD/MM/YY") : "";
  },
  getPreviewableHTML_old(htmlString: string): string {
    return htmlString.replace(
      /<p>(\s|&nbsp;)*<\/p>/g, // matches <p></p>, <p> </p>, <p>&nbsp;</p>
      "<p><br/></p>",
    );
  },
  getPreviewableHTML(htmlString: string): string {
    return htmlString.replace(/<p([^>]*)>(\s|&nbsp;)*<\/p>/g, "<p$1><br/></p>");
  },

  generateSlug(text: string): string {
    if (!text) return "";
    return text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  },

  getResourceTypeLabel(type?: string | null): string {
    if (!type) return "-";

    const mapping: Record<string, string> = {
      INDUSTRY: "Industry Report",
      TENDERS: "Tender",
      PRESENTATION: "Presentation",
      KNWGROUP: "Monthly Report",
      WRKGROUP: "Working Group",
      REGULATION: "Representations",
    };

    if (mapping[type]) {
      return mapping[type];
      // return mapping[type] || type;
    }

    // fallback: convert ENUM to readable Camel Case
    return type
      .toLowerCase()
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  },

  getDiscountApplyOnLabel(applyOn?: string | null): string {
    if (!applyOn) return "-";
    const mapping: Record<string, string> = {
      EVENT: "Event",
      PLAN: "Membership",
      REPORT: "Industry Report",
    };
    return mapping[applyOn] || applyOn;
  },  

   normalizeResizeHtml(html: string) {
  if (!html) return html;

  const doc = new DOMParser().parseFromString(html, "text/html");

  const map: Record<string, string> = {
    "ql-resize-style-center": "ql-align-center",
    "ql-resize-style-right": "ql-align-right",
    "ql-resize-style-left": "ql-align-left",
    // "full" has no perfect Quill align equivalent; keep as plain block
    "ql-resize-style-full": "",
  };

  const spans = Array.from(
    doc.querySelectorAll(
      "span.ql-resize-style-center,span.ql-resize-style-left,span.ql-resize-style-right,span.ql-resize-style-full"
    )
  );

  spans.forEach((span) => {
    const img = span.querySelector("img");
    if (!img) return;

    // remove runtime-only class added by resize module
    img.classList.remove("active");

    const p = doc.createElement("p");

    const cls = Array.from(span.classList).find((c) => map[c] !== undefined);
    const quillAlign = cls ? map[cls] : "";
    if (quillAlign) p.className = quillAlign;

    // keep width attribute (this is what matters for resize persistence)
    p.appendChild(img);

    span.replaceWith(p);
  });

  return doc.body.innerHTML;
}
};

export default HelperService;
